import React from 'react';
import PercentageDelinquency from './components/PercentageDelinquency';
import FilterFrom from './components/FilterFrom';

const Configuration = () => {
  return (
    <>
      <h3 className="text-uppercase text-pink pt-3 pb-3">
        <i className="fas fa-cog mr-2"></i>
        Configuración
      </h3>
      <div className="row">
        <div className="col-md-4">
          <div className="card">
            <div className="card-body">
              <FilterFrom />
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card">
            <div className="card-body">
              <PercentageDelinquency />
            </div>
          </div>
        </div>
      </div>
      <div className="p-5"></div>
    </>
  );
};

export default Configuration;
